module.exports = __webpack_public_path__ + "img/FJC.69ff1ccc.svg";